import React from 'react';
import Container from './Container';
import valuesImage from '../images/company-values.webp';
import Button from './Buttons';

const values = [
    {
        title: 'Integrity',
        description: `Trust is the foundation of every strong relationship. We champion our clients' best interests, to hold ourselves to the highest ethical standards, and offer financial guidance you can truly count on.`,
    },
    {
        title: 'Respect',
        description: `We recognise that each client has a unique story, set of goals and financial journey. We listen closely, value every perspective, and treat everyone with genuine fairness and empathy.`,
    },
    {
        title: 'Innovation',
        description: `We're driven by progress. By welcoming fresh ideas and smarter strategies, we help our clients stay ahead of the curve. Whether through innovative services or technology, we deliver solutions that truly matter.`,
    }
];

const ValueItem = ({ title, description, isLast }) => (
    <>
        <div className="py-4">
            <h3 className="text-xl font-bold mb-1 text-holborn-blue">{title}</h3>
            <p className="text-gray-700 leading-relaxed">{description}</p>
        </div>
        {!isLast && (
            <hr className="border-t border-holborn-light-blue" />
        )}
    </>
);

const CompanyValues = () => {
    return (
        <Container className={"my-20"}>
            <div className="bg-holborn-app-blue rounded-4xl overflow-hidden">
                <div className="grid grid-cols-1 lg:grid-cols-2">

                    <div className="p-8 md:p-12 lg:p-16">
                        <h2 className="text-4xl lg:text-5xl font-extrabold mb-2 text-holborn-blue">
                            Our company values
                        </h2>
                        <p className="text-holborn-mid-blue mb-8 font-medium">
                            What makes us tick.
                        </p>

                        <div className="space-y-0">
                            {values.map((item, idx) => (
                                <ValueItem
                                    key={idx}
                                    title={item.title}
                                    description={item.description}
                                    isLast={idx === values.length - 1}
                                />
                            ))}
                        </div>
                    </div>

                    <div className="relative min-h-[400px] hidden lg:block lg:min-h-full">
                        <img
                            src={valuesImage}
                            alt="Two colleagues shaking hands in a modern office, representing company values"
                            className="absolute inset-0 w-full h-full object-cover"
                        />

                        <div className="absolute bottom-6 right-6 z-10">
                            <Button
                                to="/about/"
                                variant="white"
                                className="px-6 py-3 font-bold rounded-full shadow-lg transition duration-300"
                            >
                                Read about Holborn
                            </Button>
                        </div>
                    </div>

                </div>
            </div>
        </Container>
    );
};

export default CompanyValues;